import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import { Spinner } from '@/components/Spinner';

function LoadingScreen() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Spinner />
    </div>
  );
}

/** Wraps the authenticated app — redirects anonymous visitors to /login. */
export function RequireAuth() {
  const { status } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status !== 'authenticated') return <Navigate to="/login" replace />;
  return <Outlet />;
}

/** Wraps public pages (login) — sends authenticated users to the dashboard. */
export function PublicOnly() {
  const { status } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}

/** Admin-only (role 2). Authenticated non-admins are bounced to the dashboard. */
export function RequireAdmin() {
  const { status, user } = useAuth();
  if (status === 'loading') return <LoadingScreen />;
  if (status !== 'authenticated') return <Navigate to="/login" replace />;
  if (user?.role !== 2) return <Navigate to="/" replace />;
  return <Outlet />;
}
